$.fn.selectRange = function (start, end) {
  let e = $(this)[0];
  if (e.setSelectionRange) {
    e.focus();
    e.setSelectionRange(start, end);
  } /* WebKit */
  else if (e.createTextRange) {
    let range = e.createTextRange();
    range.collapse(true);
    range.moveEnd('character', end);
    range.moveStart('character', start);
    range.select();
  } /* IE */
  else if (e.selectionStart) {
    e.selectionStart = start;
    e.selectionEnd = end;
  }
};

// Cálculo del dígito verificador de un RUT
$.fn.calcularDv = function (T) {
  let M = 0, S = 1;
  for (; T; T = Math.floor(T / 10))
    S = (S + T % 10 * (9 - M++ % 6)) % 11;
  return S ? S - 1 : 'k';
};

// Select 2 default theme
$.fn.select2.defaults.set("theme", "bootstrap");

// Permite validar campos del tipo "nombre[]"
$.validator.prototype.checkForm = function () {
  this.prepareForm();
  for (let i = 0, elements = (this.currentElements = this.elements()); elements[i]; i++) {
    if (this.findByName(elements[i].name).length !== undefined && this.findByName(elements[i].name).length > 1) {
      for (let cnt = 0; cnt < this.findByName(elements[i].name).length; cnt++) {
        this.check(this.findByName(elements[i].name)[cnt]);
      }
    } else {
      this.check(elements[i]);
    }
  }
  return this.valid();
};

$.validator.addMethod('custom-slug', function (value, element) {
  return this.optional(element) || /^[a-z0-9]+([.\-][a-z0-9]+)*$/.test(value);
}, "Por favor, ingrese un slug v\u00e1lido");

$.validator.addMethod('codigo-contenedor', function (value, element) {
  return this.optional(element) || /^[aA-zZ]{4}[\d]{6}-\d$/.test(value);
}, "Por favor, ingrese un código de contenedor v\u00e1lido");

$.validator.addMethod('rut', function (value) {
  const aRut = value.split('-');

  if (aRut.length !== 2) return false;

  let dv = $.fn.calcularDv(aRut[0]);
  value = aRut[1];
  value = isNaN(value) ? value.toLowerCase() : parseInt(value);

  return dv === value;
}, "Por favor, ingrese un RUT v\u00e1lido");

$.validator.addMethod('multiemail', function (value, element) {
  if (this.optional(element)) return true;

  const emails = value.split(/[;,]+/);
  let valid = true;
  emails.forEach(email => {
    valid = valid && $.validator.methods.email.call(this, $.trim(email), element);
  });

  return valid;
}, jQuery.validator.messages.email);
